export default "__VITE_ASSET__DAiYH$_p__"